import React, { useState } from "react";
import { Link } from "react-router-dom";
import img_logo from "../../images/logo.png";
import { ItemsNavbar } from "./ItemsNavbar";
import { itemsNavbar } from "../../utils/itemsNavbar";
import { HeaderStyled } from "../../styledComponents/HeaderStyled";
import { handleOnClickLogo } from "../../ReactGA";

export function Header() {
  return (
    <HeaderStyled>
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light p-0 ">
          <Link
            to="/"
            className="nav-link text-uppercase"
            onClick={handleOnClickLogo}
          >
            <img src={img_logo} alt="" className="mt-2 mb-2" />
          </Link>
          <button
            className="navbar-toggler bg-white"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav">
              {itemsNavbar.map((item) =>
                <ItemsNavbar
                  key={item.to}
                  to={item.to}
                  title={item.title}
                  className={item.className}
                  subItems={item?.subItems}
                />
              )}
            </ul>
          </div>
        </nav>
      </div>
    </HeaderStyled>
  );
}
